module.exports = __webpack_public_path__ + "img/selected2-min.43f8db7c.png";